import React from 'react';

import PluridIcon from '../../PluridIcon';

import {
    PluridIconProperties,
} from '../../interfaces';



const PluridIconVariable: React.FC<PluridIconProperties> = (
    properties,
) => {
    return (
        <PluridIcon
            {...properties}
        >
            <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 1000">
                <path d="M827.63,455.91q35.82,20.67,38.53,46.27t-30.48,44.88q-27.39,15.91-53.51,15.5T740.25,553c-7.39-4.27-11-9.17-10.92-14.7s3.87-10.44,11.33-14.78q16.13-9.37,43.88-10.61,5.4-20.34-16.24-32.85Q733.53,460,677.74,468.35q-21.37,3.58-140.37,44.47T402.15,563.16q-24.61,14.3-20.38,29t24.16,26.25q28.85,16.65,76.2,18.59t96.12-11.15q11.7-2.83,17.38-1.7t20.66,9.75l9,5.17q16.63,9.6,6.85,15.3-29.37,17.07-126,21.27T344.9,642.61q-55.57-32.08-41.61-72.12Q215.52,567,172.28,542q-35.62-20.57-38.42-46.21t30.4-44.94q27.36-15.9,53.87-15.26t43.67,10.54c8.5,4.9,13.05,10.3,13.71,16.21s-3,11.16-10.9,15.76q-15.13,8.79-49.84,6.77-5.22,20.23,17.27,33.2,33.92,19.59,88.47,12,22.22-3.1,141.41-44.6t135.43-50.94q45.85-26.65-.73-53.54c-20.25-11.69-44.71-17.8-74.16-18.83a305.53,305.53,0,0,0-84.8,8.57q-20.37,5-27.26,4.88t-15.69-5.23L383,363.55q-20.61-11.9-10.81-17.57,30-17.44,125.16-21.66t158.13,32.17q57.54,33.21,42.74,72Q781.83,429.48,827.63,455.91Z"/>
            </svg>
        </PluridIcon>
    );
}


export default PluridIconVariable;
